// IframeProtector.jsx
import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { getIsInIframe } from '../resource/getJsEnvironment.js';
import { EMPTY_ARRAY } from '../resource/defaults.js';

const DEFAULT_REDIRECT_URL =
  'https://www.bing.com/search?q=%E9%98%B2%E8%A9%90%E9%A8%99'; // TODO: remote config

export const IframeProtector = ({ iframeMainDomainList = EMPTY_ARRAY }) => {
  const getParentUrl = () => {
    let url = document.referrer;

    try {
      if (window.location.origin === window.parent.location.origin)
        url = window.parent.location.href;
      else url = document.referrer;
      // eslint-disable-next-line no-empty
    } catch (e) {}

    if (url) return new URL(url);
  };

  useEffect(() => {
    if (getIsInIframe()) {
      const parentUrl = getParentUrl();

      // In iframe, redirect to the url if the followings
      // 1. can not get the parent url
      // 2. get the parent url but not in the IFRAME_MAIN_DOMAIN_WHITELIST
      if (
        !parentUrl ||
        !iframeMainDomainList.some(url => parentUrl.host.includes(url))
      ) {
        window.location = DEFAULT_REDIRECT_URL;
      }
    }
  }, [iframeMainDomainList]);

  return null;
};

IframeProtector.propTypes = {
  iframeMainDomainList: PropTypes.array,
};

export default IframeProtector;
